export default "__VITE_ASSET__BoVfzbxB__"